import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Box, Button, VStack, Heading, Span, Text } from '@bpba/ui-components';
import { AdhesionComercioCanjeModel } from "../rest/models/AdhesionComercioCanjeModel";
import { useLazyQuery} from "@apollo/client";

import { getCanjeComercioCDNI } from "../rest/queries/getCanjeComercioCDNI";
import { AdhesionComercioCanjeData } from '../rest/models/AdhesionComercioCanjeData';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { Result } from './Result';
import { ResultError } from './ResultError';
import { useTurnstile } from 'react-turnstile';





const validateRealCuit = (cuit: string) => {
    let rv = false;

    let resultado = 0;
    const codes = "6789456789";
    let verificador = parseInt(cuit[cuit.length - 1]);
    let x = 0;

    while (x < 10) {
        let digitoValidador = parseInt(codes.substring(x, x + 1));
        if (isNaN(digitoValidador)) digitoValidador = 0;
        let digito = parseInt(cuit.substring(x, x + 1));
        if (isNaN(digito)) digito = 0;
        let digitoValidacion = digitoValidador * digito;
        resultado += digitoValidacion;
        x++;
    }
    resultado = resultado % 11;
    rv = resultado === verificador;

    return rv ? rv : "Verifique el Cuit ingresado";
};



const AdhesionComercioCanjeComponente: React.FC = () => {

    const { register, handleSubmit, reset, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {

        }
    });

    const REQUIRED_FIELD = "Campo requerido.";
    const [cuitValidado, setCuitValidado] = useState<boolean>(false);
    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<React.ReactNode>("");
    
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [getTrnToken, setGetTrnToken] = useState<boolean>(false);
    

    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [canjesCDNI, setCanjesCDNI] = useState<Array<AdhesionComercioCanjeData>>();
    const toknTurnstile= useTurnstile();
    
    
    
    const [triggerCanjes, { loading: loadingCanje }] = useLazyQuery(getCanjeComercioCDNI, {
        fetchPolicy: 'network-only',
        onCompleted: handleCanjes,
        onError: handleError,
    });
   
    function handleCanjes(data: any) {
        setGetTrnToken(false);
        
        if (!data.canjeComercioCDNI) {
            setErrorServicio(true);
            setServicioOk(true);
            setMensajeErrorPostProspecto("No hay promociones disponibles.");
        } else {
            
            if (data.canjeComercioCDNI.length !== 0) {
                setServicioOk(false);
                setErrorServicio(false);
                setCuitValidado(true);
                setCanjesCDNI(data.canjeComercioCDNI);
            } else {
                setServicioOk(false);
                setErrorServicio(true);
                setMensajeError(<Box display={"flow"} >¡Ups! Tu comercio no tiene promo. <br />Si no estas adherido a los beneficios de Cuenta DNI, podés sumarte <a href="https://www.bancoprovincia.com.ar/cuentadni/contenidos/cdniComercios?utm_source=canjepop&utm_medium=Organico&utm_campaign=canjepop_adhesioncdni&utm_id=canjepop_adhesioncdni&utm_term=canjepop_adhesioncdni&utm_content=canjepop_adhesioncdni" style={{ color: "red", fontWeight: "bold" }}>acá</a>. </Box>);  
            }

        }
        
    }
    function handleError(e: any) {
        setGetTrnToken(false);
        
        if (e.networkError.statusCode === 409) {
            setServicioOk(false);
            setErrorServicio(true);
            setMensajeError(<Box display={"flow"} >¡Ups! Tu comercio no tiene promo. <br />Si no estas adherido a los beneficios de Cuenta DNI, podés sumarte <a href="https://www.bancoprovincia.com.ar/cuentadni/contenidos/cdniComercios?utm_source=canjepop&utm_medium=Organico&utm_campaign=canjepop_adhesioncdni&utm_id=canjepop_adhesioncdni&utm_term=canjepop_adhesioncdni&utm_content=canjepop_adhesioncdni" style={{ color: "red", fontWeight: "bold" }}>acá</a>. </Box>);
        } else {
            setMensajeErrorPostProspecto("No hay promociones disponibles.");
        }
        
    }
    


    if (getTrnToken) return <SpinnerCajas />;

    const handleReset = () => {
        reset({});
        window.location.reload();
    };

    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );
    
   
    const onSubmit: SubmitHandler<AdhesionComercioCanjeModel> =  (data: AdhesionComercioCanjeModel) => {
        setGetTrnToken(true);
        toknTurnstile.execute(document.getElementById('turnStileTkncontainer'),{
            sitekey: process.env.REACT_APP_TKN_SITEKEY!,
            callback: (token:any)=>{triggerCanjes({ variables: { cuit: data.cuit },
                context: { headers: { "googleToken": token } } })
            }});
            
 
    };
    
    return (

        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>
                    

                    {!cuitValidado ?
                        (<>
                            <Heading level={3} mb={0} fontWeight={400} tabIndex={0}>
                                Poné tu CUIT acá:
                            </Heading>
                            {errorServicio ?
                                <VStack mt={"20px"}>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {mensajeError}
                                    </Span>
                                    <Button
                                        onClick={() => handleReset()}
                                        variant="secondary"
                                        py={"10px !important"}
                                    >
                                        Volver
                                    </Button>
                                </VStack> : <>


                                    <VStack mt={"20px"}>
                                        <input type={"text"} tabIndex={0}
                                            {...register("cuit", {
                                                required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                                maxLength: 13, validate: (value) => validateRealCuit(value.toString())
                                            })}
                                            name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={13} minLength={11} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                                            {errors.cuit ? "* " + errors.cuit.message : ""}
                                        </Span>
                                        <Button type="submit" variant="secondary" py={"10px !important"}>Validar</Button>
                                    </VStack>
                                </>
                            }




                        </>) : (<>

                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                ¡Tu comercio tiene promo!
                            </Heading>
                            {errorServicio ?
                                <VStack mt={"20px"}>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {mensajeError}
                                    </Span>
                                </VStack> : <></>
                            }
                            {canjesCDNI &&
                                canjesCDNI.map((item: AdhesionComercioCanjeData) =>
                                    <VStack mt={"20px"}>
                                        <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                            {item.tituloFormulario}
                                        </Heading>
                                        <Heading level={4} mb={'2px'} fontWeight={400} tabIndex={0} color="#3c3c3">
                                            {item.subtituloFormulario}
                                        </Heading>
                                        {item.linkPromo1 ?
                                            <Button type="button" variant="secondary" style={{ height: "auto" }} py={'10px !important'} onClick={() => window.open(item.linkPromo1, '_blank')} > {item.botonPromo1}</Button>
                                            : <></>}
                                        {item.linkPromo2 ?
                                            <Button type="button" variant="secondary" style={{ height: "auto" }} py={'10px !important'} onClick={() => window.open(item.linkPromo2, '_blank')} >{item.botonPromo2}</Button>
                                            : <></>}
                                    </VStack>
                                )}
                        </>)}



                </form>
            </VStack>

        </Box>

    )

};



export default AdhesionComercioCanjeComponente;
